import { Component } from "@angular/core";

@Component({
  selector: "privacy-policy-page",
  templateUrl: "privacy-policy.page.html"
})
export class PrivacyPolicyPage {
  constructor(
  ) {
    // No empty block
  }

}



// WEBPACK FOOTER //
// ./src/pages/privacy-policy.page/privacy-policy.page.ts